// extracted by mini-css-extract-plugin
module.exports = {"lineChartAxis":"LineChartAxis__lineChartAxis__zKwDF"};